import { post, get } from '@/utils/request'

//获取预定列表
export function getAppointmentList(data) {
  return post({
    data,
    url: 'tbs/appointment/list'
  })
}

//添加营销跟进
export function addAppointmentFollow(data){
  return post({
    data,
    url: 'tbs/appointment/addFollow'
  })
}

//获取营销跟进日志
export function getAppointmentFollowList(id){
    return get({
      url: `tbs/appointment/getFollowList/${id}`,
    })
}


// 导出预约信息表格数据
export function exportAppointent(id){
  return get({
    url: `tbs/appointment/export/${id}`,
  })
}